import { Typography } from "antd";
import { Fragment } from "react";
import { ReactComponent as CloseIcon } from "../../../../../common/images/svg/CloseIcon.svg";
import useResponsive from "../../../../../utils/hooks/useResponsive";

interface ITitleModalProps {
  stepNewBeneficiary: number | null;
  listStep: any[];
  handleStep: (step: number) => void;
  handleCloseModalBeneficiary: () => void;
}

const TitleModal = ({
  stepNewBeneficiary,
  handleCloseModalBeneficiary,
  listStep,
}: ITitleModalProps) => {
  const { isTablet } = useResponsive();
  console.log('stepNewBeneficiary...........', stepNewBeneficiary);
  return (
    <>
      <Typography
        style={{
          fontSize: isTablet ? 16 : 20,
          fontWeight: 700,
          color: "#C2C6CE",
        }}
      >
        {"Add Beneficiary"}
      </Typography>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "24px",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "16px",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          {stepNewBeneficiary &&
            listStep.map((item, index) => (
              <Fragment key={index}>
                {item.step < stepNewBeneficiary ? (
                  <div
                    className="step-previous"
                  // onClick={() => handleStep(item.step)}
                  >
                    <div className="radio-previous">
                      <div className="radio-previous-icon">
                        <Typography>{item.step}</Typography>
                      </div>
                    </div>
                  </div>
                ) : item.step === stepNewBeneficiary ? (
                  <div className="step-current">
                    <Typography className="text-step">{item.name}</Typography>
                    <div className="radio-current">
                      <div className="radio-current-icon"></div>
                    </div>
                  </div>
                ) : (
                  <div className="step-next">
                    <Typography>{item.step}</Typography>
                  </div>
                )}
                {index < listStep.length - 1 && (
                  <div className="three-dot">
                    {[1, 2, 3].map((itemDot) => (
                      <div
                        key={itemDot}
                        className={
                          item.step < stepNewBeneficiary
                            ? "three-dot__circle"
                            : "three-dot__circle-inactive"
                        }
                      ></div>
                    ))}
                  </div>
                )}
              </Fragment>
            ))}
        </div>
        <CloseIcon
          onClick={handleCloseModalBeneficiary}
          className="icon-animation"
        />
      </div>
    </>
  );
};

export default TitleModal;
